// frontend/src/site/lib/normalizeSiteConfig.js
import { SITE_PRESETS } from '../theme/presets';

/**
 * Aliases para "preset" (para aceitar valores antigos / variações)
 * Ex.: 'humano' -> 'humano_a'
 */
const PRESET_ALIASES = {
  humano: 'humano_a',
  humanoa: 'humano_a',
  'humano-a': 'humano_a',
  humano_a: 'humano_a',

  classico: 'humano_a',
  classico_a: 'humano_a',

  // adicione outros aliases conforme seus presets reais
  // aurora: 'aurora_a',
  // premium: 'premium_a',
};

function asObj(v) {
  return v && typeof v === 'object' && !Array.isArray(v) ? v : {};
}

function asStr(v) {
  return String(v ?? '').trim();
}

function resolvePreset(raw) {
  const key = asStr(raw).toLowerCase();
  if (!key) return 'humano_a';

  const mapped = PRESET_ALIASES[key] || key;

  // se não existir no preset final, cai no default
  return SITE_PRESETS[mapped] ? mapped : 'humano_a';
}

/**
 * Decide modelId do site.
 * Regras:
 * 1) Se veio definido no Firestore, respeita SEMPRE.
 * 2) Senão, se veio "siteTemplate" no topo (ex.: lovable), usa isso.
 * 3) Senão, inferência por preset.
 * 4) Default global: lovable (para ficar válido pra todos novos usuários)
 */
function inferModelId(rawCfg, preset, topLevelTemplate) {
  // 1) explícito em siteConfig.modelId
  const explicit = asStr(rawCfg?.modelId).toLowerCase();
  if (explicit) return explicit; // 'corretor' | 'imobiliaria' | 'lovable' | etc

  // 2) top-level siteTemplate (quando existir)
  const tpl = asStr(topLevelTemplate).toLowerCase();
  if (tpl) {
    // se você usar "lovable" como template, converte em modelId também
    if (tpl === 'lovable') return 'lovable';
    // se tiver outros, retorne como modelId padrão
    return tpl;
  }

  // 3) inferência por preset (nomes comuns)
  const p = asStr(preset).toLowerCase();

  const looksAgency =
    p.includes('imobili') ||
    p.includes('realty') ||
    p.includes('agency') ||
    p.includes('brokerage');

  if (looksAgency) return 'imobiliaria';

  // 4) ✅ default global
  return 'lovable';
}

/**
 * Normaliza siteConfig vindo do Firestore
 * - garante objeto
 * - garante preset válido
 * - garante modelId (com inferência)
 *
 * Entrada esperada: userData (doc inteiro de users/{uid})
 * Saída: userData com siteConfig normalizado
 */
export function normalizeSiteConfig(userData) {
  const data = asObj(userData);
  const rawCfg = asObj(data.siteConfig);

  const preset = resolvePreset(rawCfg.preset);

  // pode existir no topo do doc: siteTemplate: 'lovable'
  const topLevelTemplate = data.siteTemplate;

  const modelId = inferModelId(rawCfg, preset, topLevelTemplate);

  return {
    ...data,
    siteConfig: {
      // mantém overrides manuais
      ...rawCfg,

      // ✅ garante preset/modelId válidos por último
      preset,
      modelId,
    },
  };
}
